import { Row } from "antd";
import styled from "styled-components";

export const PhotoSection = styled.section<{ background?: string }>`
  position: relative;
  background: ${({ background }) =>
        background ? `url(${background}) no-repeat center center/cover` : "none"};
  width: 100%;
  height: 75vh;
  padding-top: 4rem;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(42, 50, 115, 0.7); 
    z-index: 1;
  }

  display: flex;
  justify-content: center;
  align-items: center;


  @media only screen and (max-width: 890px) {
    padding: 4rem 0;
    height: 60vh;
  }

  @media only screen and (max-width: 414px) {
    padding: 4rem 0;
    height: 60vh;
  }

  > * {
    position: relative;
    z-index: 2;
  }
`;

export const StyledRow = styled(Row) <{ direction: string }>`
  flex-direction: ${({ direction }) =>
        direction === "up" ? "row" : "row-reverse"};
`;

export const ContentHead = styled("div")`
  font-family: 'Gilroy Semibold', serif;
  color: #FFFFFF;
  font-size: 18px;
  text-align: center;
  line-height: 1;

  @media only screen and (max-width: 890px) {
    font-size: 16px;
  }

  @media only screen and (max-width: 414px) {
    font-size: 16px;
  }
`;

export const ContentLocation = styled("div")`
  font-family: 'Gilroy Bold', serif;
  color: #FFB4AB;
  font-size: 90px;
  text-align: center;
  line-height: 1;

  @media only screen and (max-width: 890px) {
    font-size: 60px;
  }

  @media only screen and (max-width: 414px) {
    font-size: 60px;
  }
`;

export const ContentSublocation = styled("div")`
  font-family: 'Gilroy Semibold', serif;
  color: #FFFFFF;
  font-size: 30px;
  text-align: center;
  line-height: 1;

  @media only screen and (max-width: 890px) {
    font-size: 20px;
  }

  @media only screen and (max-width: 414px) {
    font-size: 20px;
  }
`;


export const ContentText = styled("div")`
  font-family: 'Gilroy Light', serif;
  color: #FFFFFF;
  text-align: left;
  font-size: 18px;
  padding-top: 4rem;
  
  @media only screen and (max-width: 890px) {
    font-size: 16px;
    padding-top: 4rem;
  }

  @media only screen and (max-width: 414px) {
    font-size: 16px;
    padding-top: 4rem;
  }
`;

export const ContentDate = styled("div")`
  font-family: 'Gilroy Semibold', serif;
  color: #FFFFFF;
  text-align: left;
  font-size: 32px;
  line-height: 1;
  
  @media only screen and (max-width: 890px) {
    font-size: 20px;
  }

  @media only screen and (max-width: 414px) {
    font-size: 20px;
  }
`;

export const ContentTextSmall = styled("div")`
  font-family: 'Motiva Sans Light', serif;
  color: #000000;
  text-align: left;
  font-size: 22px;

  @media only screen and (max-width: 890px) {
    font-size: 14px;
  }

  @media only screen and (max-width: 414px) {
    font-size: 14px;
  }
`;

export const VerticalStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;  /* Add a small gap to reduce spacing */
`;



export const ContentWrapper = styled("div")`
  position: relative;
  max-width: 540px;
  padding-left: 50px;

  @media only screen and (max-width: 575px) {
    padding-top: 4rem;
  }
`;

export const ServiceWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  max-width: 100%;
`;


export const MinPara = styled("p")`
  font-size: 13px;
`;

export const ButtonWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  max-width: 100%;

  @media screen and (min-width: 1024px) {
    max-width: 80%;
  }

  button:last-child {
    margin-left: 20px;
  }
`;
